import { Component, Inject, OnInit, AfterViewInit } from '@angular/core';
import { HandModel } from "./Poker.HandModel";
import { CardModel } from "./Poker.CardModel";
import { OptionModel } from "./Poker.OptionModel";
import { AppMaterialModule } from './material-module';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-root',
    templateUrl: './Poker.HandView.html'
})

export class HandComponent implements OnInit, AfterViewInit {

handModel = new HandModel();

  imageStyles: {};

    constructor(public dialog: MatDialog) {}

    ngOnInit(): void {
      let height1 = Math.floor(window.screen.availHeight / 8);
      let height2 = height1.toString().trim() + 'px';
      if (height1 > 80) height2 = '80px';

      this.imageStyles = {
        width: '100%',
        height: height2
      };
    }

    public get canDeactivate() {
      return false;
      return this.handModel.isGameComplete || !this.handModel.isGameStarted;
    }

    ngAfterViewInit() {
    }
  
    newGame(): void {
      if (!this.handModel.isGameStarted || this.handModel.isGameComplete) {
        this.handModel.newGame();
      }
      else {
        if (confirm("Game in progress, are you sure?")) {
          this.handModel.newGame();
        };
      }
    }
    
    openOptionDialog(): void {
      const dialogRef = this.dialog.open(OptionDialogData, {
        width: '250px',
        data: this.handModel.options
      });
      dialogRef.afterClosed().subscribe(result => {
        this.handModel.setOptions();
      });
    }

  }  

/**
 * @title Injecting data when opening a dialog
 */

@Component({
  templateUrl: 'Poker.OptionDialogue.html',
})

export class OptionDialogData {
  constructor(@Inject(MAT_DIALOG_DATA) public options: OptionModel) {}
}
